exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-header{padding-top:.7rem}@media (min-width:60em){.c-header{margin-bottom:.375rem;width:50%}}", ""]);

// exports
